import { render, staticRenderFns } from "./dashboard-delivered.vue?vue&type=template&id=e70249b6&scoped=true&"
import script from "./dashboard-delivered.vue?vue&type=script&lang=js&"
export * from "./dashboard-delivered.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-delivered.vue?vue&type=style&index=0&id=e70249b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70249b6",
  null
  
)

export default component.exports